/* Tabbed mega menu behaviour.
   Listeners are delegated from the document because mega menu markup is
   injected by Concept's Section Rendering API after page load. */
(function () {
  'use strict';

  function panelsOf(root) {
    return Array.from(root.querySelectorAll('[data-mm-panel]'));
  }

  function tabsOf(root) {
    return Array.from(root.querySelectorAll('[data-mm-tab]'));
  }

  function activate(tab) {
    var root = tab.closest('[data-mm-tabs]');
    if (!root) return;

    var tabs = tabsOf(root);
    var panels = panelsOf(root);
    var index = tabs.indexOf(tab);
    if (index === -1) return;

    tabs.forEach(function (t, i) {
      var on = i === index;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
    });

    panels.forEach(function (p, i) {
      var on = i === index;
      p.classList.toggle('is-active', on);
      if (on) {
        p.removeAttribute('hidden');
      } else {
        p.setAttribute('hidden', '');
      }
    });
  }

  document.addEventListener('pointerover', function (event) {
    var tab = event.target.closest && event.target.closest('[data-mm-tab]');
    if (tab) activate(tab);
  });

  document.addEventListener('click', function (event) {
    var tab = event.target.closest && event.target.closest('[data-mm-tab]');
    if (!tab) return;
    event.preventDefault();
    activate(tab);
  });

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest && event.target.closest('[data-mm-tab]');
    if (!tab) return;

    var root = tab.closest('[data-mm-tabs]');
    if (!root) return;

    var tabs = tabsOf(root);
    var i = tabs.indexOf(tab);
    var next = null;

    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
      next = tabs[(i + 1) % tabs.length];
    } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
      next = tabs[(i - 1 + tabs.length) % tabs.length];
    } else if (event.key === 'Home') {
      next = tabs[0];
    } else if (event.key === 'End') {
      next = tabs[tabs.length - 1];
    }

    if (next) {
      event.preventDefault();
      activate(next);
      next.focus();
    }
  });
})();
